"use strict";
function speakerDisplayName(speaker) {
  return (typeof speaker?.displayName === "string" && speaker.displayName.trim())
    || (typeof speaker?.name === "string" && speaker.name.trim()) || "";
}
function formatCourseDisplayPrice(course) {
  const price = course?.displayPrice;
  if (!price || !["demo", "inquiry", "free", "paid"].includes(price.mode)
    || price.currency !== "USD" || !Number.isSafeInteger(price.priceMinor)
    || price.priceMinor < 0 || price.priceMinor > 100000000
    || (price.mode === "paid" && price.priceMinor === 0)
    || (price.mode === "free" && price.priceMinor !== 0)) return "Price not set";
  return price.mode === "free" ? "Free" : new Intl.NumberFormat("en-US", { style: "currency", currency: price.currency }).format(price.priceMinor / 100);
}
module.exports = { speakerDisplayName, formatCourseDisplayPrice };
